import { useTheme } from '@/components/ThemeProvider';
import { SortTypeEnum } from '@/request/request.enum';
import { SortIcon } from '@/widget/Icon';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import { SortConfig } from '../..';

interface IProps {
  handleSort: (key: SortConfig['key']) => void;
  getSortStatus: (key: SortConfig['key']) => SortTypeEnum;
}
export default memo((props: IProps) => {
  const { handleSort, getSortStatus } = props;
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <div className="flex items-center text-secondaryTextColor text-[12px] h-[32px] sticky top-0 left-0 right-0 bg-primaryBgColor z-10">
      <div className="w-[120px]">{t('Signal.token')}</div>
      <div className="flex-1 ">
        <div className="flex items-center px-0 justify-center" onClick={() => handleSort('time')}>
          <span>{t('Signal.alertTime')}</span>
          {/* <SortIcon theme={theme} status={getSortStatus('time')} className="w-[16px] h-[16px]" /> */}
        </div>
      </div>
      <div className="w-[96px]">
        <div className="flex items-center justify-end" onClick={() => handleSort('chg')}>
          <span>{t('Signal.maxIncrease')}</span>
          <SortIcon theme={theme} status={getSortStatus('chg')} className="w-[16px] h-[16px]" />
        </div>
      </div>
    </div>
  );
});
